/**
 * Tooltip initialisation and usage
 *
 * @copyright 2018 Linguistica 360
 */

import 'jquery-ui/ui/widgets/tooltip.js';

import { Script, injector } from '../shared/injector.js';
import { hasGroup, resolveRoot } from '../shared/utils.js';

import $ from 'jquery';

import { LANGUAGE } from '../shared/config.js';

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

let firstTime = true;

export const Tooltip = injector.injectClass(class extends Script {
    onLoad() {
        // our tooltip modification to allow double tap on mobile devices
        $.widget('ui.tooltip', $.ui.tooltip, {
            _create: function () {
                this._on({ click: 'open' });
                this._super();
            },
        });

        $('body').tooltip({
            items: '[data-tooltip],[data-tooltip-reference]',
            content: this.$wrap(this.getContent),
            open: (e) => this.onTooltipOpen(e),
            close: () => this.onTooltipClose(),
            position: { my: 'center bottom-10', at: 'center top' },
        });

        $('body').on('click', '[data-tooltip-reference]', function (e) {
            e.preventDefault();

            if (!isTouchDevice() || !firstTime) {
                const href = $(this).data('href');
                const url = resolveRoot(href);
                window.open(url, '_blank');
            }
            else firstTime = false;
        });

        this.timeout = null;
        this.pm = false;

        if (hasGroup('presentation')) {
            console.log('User belongs to presentation group');
            this.initPresentation();
        }
    }

    getExpressions($tooltip) {
        const head = LANGUAGE + ' Expression';

        let meaning = '';
        if ($tooltip.data('tooltip-meaning')) {
            meaning = $tooltip.data('tooltip-meaning');
            meaning = `<span style="font-style: italic;">${meaning}</span>`;
            meaning = `<h4>Meaning: ${meaning}</h4><br>`;
        }

        const body = 'Click/Tap on the expression twice to open in a new tab';
        const $div = $(`<div><h3>${head}</h3>${meaning}<h4>${body}</h4></div>`);

        $div.on('click', () => {
            const href = $tooltip.data('href');
            const url = resolveRoot(href);
            window.open(url, '_blank');
        });

        return $div;
    }

    getContent($tooltip) {
        const reference = $tooltip.data('tooltip-reference');
        if (reference) {
            if (reference === 'expressions') {
                return this.getExpressions($tooltip);
            }
        }

        return $tooltip.data('tooltip');
    }

    onTooltipOpen(e) {
        if (!isTouchDevice() && !this.pm) return;

        clearTimeout(this.timeout); // clear old timeout if its still not run
        this.timeout = setTimeout(() => {
            $('body').tooltip('close', {
                type: 'mouseleave',
                currentTarget: e.originalEvent.target,
            });
        }, 3000);
    }

    onTooltipClose() {
        firstTime = true;

        clearTimeout(this.timeout); // clear old timeout if its still not run

        // we don't want accessible stuff sticking on the bottom
        $('.ui-helper-hidden-accessible').remove();
    }

    hideTooltip() {
        const $shown = $('.ui-tooltip');

        if ($shown.length) {
            this.$tooltips.trigger('mouseleave');
            return true;
        }

        return false;
    }

    showTooltip() {
        if (this.index < this.$tooltips.length) {
            const $tooltip = $(this.$tooltips[++this.index]);
            $tooltip.trigger('mouseover');
        }
    }

    initPresentation() {
        this.index = 0;
        this.$tooltips = [];

        $(document).on('keydown', (e) => {
            switch (e.code) {
                case 'ArrowUp': {
                    // up

                    this.index = -1;

                    const cc = '.content-container';
                    const t1 = `${cc} [data-tooltip]:visible`;
                    const t2 = `${cc} [data-tooltip-reference]:visible`;
                    this.$tooltips = $(`${t1},${t2}`);

                    this.pm = true;
                    console.log('Presentation mode enabled');
                    break;
                }
                case 'KeyQ': {
                    // Q

                    if (!this.pm) return;
                    if (this.hideTooltip()) {
                        setTimeout(() => this.showTooltip(), 100);
                    }
                    else this.showTooltip();
                    break;
                }
                case 'ArrowDown': {
                    // down

                    this.index = 0;
                    this.$tooltips = [];
                    this.pm = false;
                    console.log('Presentation mode disabled');
                    break;
                }
            }
        });
    }
});
